import { createSelector } from "reselect";

/**
 * selector to determine if patient overview notes is enabled
 */
export const patientOverviewNotesEnabledSelector = createSelector(() => false);
